import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Typography,
  Divider,
} from 'antd';
import { SendOutlined } from '@ant-design/icons';
import { postSolicitudCambioPassword } from 'api/usuarios/auth';
import useQuery from 'hooks/useQuery';

const { Text } = Typography;

const RecuperacionDeContrasena = () => {
  const navigate = useNavigate();
  const [email] = useQuery(['email']);

  if (!email) {
    navigate('/inicio-de-sesion');
  }

  const resend = async () => {
    const sent = await postSolicitudCambioPassword({ email });
    if (sent) {
      setTimeout(() => {
        navigate(`/recuperacion-de-contrasena?email=${email}`);
      }, 500);
    }
  };

  return (
    <>
      <Text style={{ textAlign: 'center' }}>
        Enviamos un correo electrónico a
        {' '}
        <b style={{ color: '#D88F4F' }}>
          {email}
        </b>
        {' '}
        con un enlace para recuperar su contraseña.
        Sigue el enlace para continuar con el proceso.
      </Text>
      <br />
      <Button
        style={{
          width: '150px',
        }}
        className="auth-submit-button"
        onClick={() => navigate('/inicio-de-sesion')}
      >
        Continuar
      </Button>
      <Divider style={{ margin: '10px 0' }} />
      <Text>
        ¿No recibiste nuestro correo electrónico?
        <Button
          type="link"
          className="auth"
          style={{
            padding: 0,
            marginLeft: 5,
          }}
          onClick={resend}
        >
          Reenviar
          <SendOutlined />
        </Button>
      </Text>
      <br />
      <Text>
        Puedes cerrar esta ventana si ya has terminado.
      </Text>
    </>
  );
};

export default RecuperacionDeContrasena;
